import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store";
import { setDirection } from "store/theme/themeSlice";

function useDirection() {
  const direction = useAppSelector((state) => state.theme.direction);

  const dispatch = useAppDispatch();
  const updateDirection = (dir) => dispatch(setDirection(dir));

  useEffect(() => {
    if (window === undefined) {
      return;
    }
    const root = window.document.documentElement;
    root.setAttribute("dir", direction);
  }, [direction]);

  return [direction, updateDirection];
}

export default useDirection;
